{
  "atlassian": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "ax-epsilon.finalized.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.social-proof": [
    {
      "type": 0,
      "value": "Over "
    },
    {
      "type": 1,
      "value": "numberOfCustomers"
    },
    {
      "type": 0,
      "value": " customers use "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " to accelerate their work"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.cross-site.accept-invite": [
    {
      "type": 0,
      "value": "Accept invite"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.cross-site.body": [
    {
      "type": 0,
      "value": "It’s separate from the "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " sites you already use. Accept the invite to get started."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.cross-site.heading": [
    {
      "type": 1,
      "value": "inviterName"
    },
    {
      "type": 0,
      "value": " invited you to a new "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " site."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.cross-site.heading-no-inviter": [
    {
      "type": 0,
      "value": "Your admin invited you to a new "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " site."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.cross-site.lozenge": [
    {
      "type": 0,
      "value": "New"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.cross-site.preheader": [
    {
      "type": 1,
      "value": "siteDisplayName"
    },
    {
      "type": 0,
      "value": " is a different "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " site from the one you already use."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.cross-site.reminder-subject": [
    {
      "type": 0,
      "value": "[Reminder] "
    },
    {
      "type": 1,
      "value": "inviterName"
    },
    {
      "type": 0,
      "value": " invited you to a new "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " site"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.cross-site.reminder-subject-no-inviter": [
    {
      "type": 0,
      "value": "[Reminder] Your admin invited you to a new "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " site"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.cross-site.subject": [
    {
      "type": 0,
      "value": "[Action Required] "
    },
    {
      "type": 1,
      "value": "inviterName"
    },
    {
      "type": 0,
      "value": " invited you to a new "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " site"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.cross-site.subject-no-inviter": [
    {
      "type": 0,
      "value": "[Action Required] Your admin invited you to a new "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " site"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.jira.description": [
    {
      "type": 0,
      "value": "A software tool for project and issue tracking across your team. Plan, track and manage your projects in Jira."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.jsm.accept-invite": [
    {
      "type": 0,
      "value": "Accept invite"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.jsm.body-with-space": [
    {
      "type": 0,
      "value": "You’ve been given access to the "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "projectName"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " space to start collaborating with your team today."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.jsm.body-without-space": [
    {
      "type": 0,
      "value": "You’ve been given access to Jira Service Management to start collaborating with your team today."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.jsm.customer-body": [
    {
      "type": 0,
      "value": "You’ve been given access to Jira Service Management to start raising requests."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.jsm.customer-logos-alt": [
    {
      "type": 0,
      "value": "Customer logos"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.jsm.customer-product-description": [
    {
      "children": [
        {
          "type": 0,
          "value": "What is Jira Service Management?"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " An AI-powered platform to deliver great service experiences."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.jsm.greeting": [
    {
      "type": 0,
      "value": "👋 G’day "
    },
    {
      "type": 1,
      "value": "recipientName"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.jsm.heading-customer": [
    {
      "type": 0,
      "value": "You’ve been invited to Jira Service Management"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.jsm.heading-generic": [
    {
      "type": 0,
      "value": "You’ve been invited to join your team in Jira Service Management"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.jsm.heading-with-inviter": [
    {
      "type": 1,
      "value": "inviterName"
    },
    {
      "type": 0,
      "value": " invited you to join your team in Jira Service Management"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.jsm.note-from-admin": [
    {
      "type": 0,
      "value": "A note from "
    },
    {
      "type": 1,
      "value": "inviterName"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.jsm.note-from-admin-fallback": [
    {
      "type": 0,
      "value": "A note from your admin"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.jsm.preheader": [
    {
      "type": 0,
      "value": "Accept your invitation to Jira Service Management"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.jsm.product-description": [
    {
      "type": 0,
      "value": "Join Jira Service Management to help your team seamlessly manage incoming requests and deliver great service."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.jsm.social-proof": [
    {
      "type": 0,
      "value": "Over 125,000 customers use Jira Service Management to accelerate their work"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.jsm.subject": [
    {
      "type": 0,
      "value": "Action required: You’ve been invited to Jira Service Management"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.jsm.subject-with-inviter": [
    {
      "type": 0,
      "value": "Action required: "
    },
    {
      "type": 1,
      "value": "inviterName"
    },
    {
      "type": 0,
      "value": " invited you to Jira Service Management"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.accept-button": [
    {
      "type": 0,
      "value": "Accept invite"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.customer-logos-alt": [
    {
      "type": 0,
      "value": "Logos of companies using "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.logo-alt": [
    {
      "type": 0,
      "value": "Product logo"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.analytics": [
    {
      "type": 0,
      "value": "A tool that provides data visualization and insights across your Atlassian products to help teams make informed decisions."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.analytics-appify": [
    {
      "type": 0,
      "value": "A tool that provides data visualization and insights across your Atlassian apps to help teams make informed decisions."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.assets": [
    {
      "type": 0,
      "value": "From laptops to llamas, bring anything you need to track into a flexible database. Link objects to work items, documents, automations, and more."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.atlas": [
    {
      "type": 0,
      "value": "A software tool to connect work across your company. Share work and get aligned across teams."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.avocado": [
    {
      "type": 0,
      "value": "A question and answer application."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.bitbucket": [
    {
      "type": 0,
      "value": "A Git-based code hosting and collaboration tool, built for teams"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.compass": [
    {
      "type": 0,
      "value": "Mission control for your distributed architecture."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.confluence": [
    {
      "type": 0,
      "value": "Get to knowledge faster with Confluence. Document, brainstorm, and collaborate on work, together."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.confluence-reinvite": [
    {
      "type": 0,
      "value": "Sending you a friendly reminder that your teammate "
    },
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " invited you to join "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": ". Start collaborating with your team today."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.default": [
    {
      "type": 0,
      "value": "Start planning, tracking, and collaborating on your work with your team today."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.feedback": [
    {
      "type": 0,
      "value": "A tool for collecting, organizing, and acting on customer and team feedback."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.focus": [
    {
      "type": 0,
      "value": "A portfolio management tool that helps leaders define and map strategic priorities and track progress with their teams."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.guard": [
    {
      "type": 0,
      "value": "An intelligent security add-on that detects suspicious activity and data misuse across your Atlassian Cloud — so you can act before threats become incidents."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.jira": [
    {
      "type": 0,
      "value": "A software tool for project and issue tracking with your team"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.jira-customer-service": [
    {
      "type": 0,
      "value": "A platform to unite Development, Operations, and Customer Service teams to resolve support cases faster and deliver exceptional customer experiences."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.jira-product-discovery": [
    {
      "type": 0,
      "value": "A tool for product teams to capture, prioritize, and transform ideas into shareable roadmaps."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.jira-reinvite": [
    {
      "type": 0,
      "value": "Sending you a friendly reminder that your teammate "
    },
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " invited you to join "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": ". Start planning and tracking your work with your team today."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.jira-service-management": [
    {
      "type": 0,
      "value": "An AI-powered platform to deliver great service experiences."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.loom": [
    {
      "type": 0,
      "value": "Loom is an easy way to create video messages of feedback, ideas, presentations, and more. Work moves forward faster, and you have fewer meetings."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.opsgenie": [
    {
      "type": 0,
      "value": "A software tool for incident management. Track on-call alerts and notifications."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.rovo": [
    {
      "type": 0,
      "value": "Start using the same AI your team uses to find answers across your apps and work faster with chat, search, and agents."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.rovo-app": [
    {
      "type": 0,
      "value": "Start using the same AI your team uses to find answers across your apps and work faster with chat, search, and agents."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.rovodev": [
    {
      "type": 0,
      "value": "Rovo Dev is a suite of AI features that help you both review and create code using Atlassian products."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.rovodev-appify": [
    {
      "type": 0,
      "value": "Rovo Dev is a suite of AI features that help you both review and create code using Atlassian apps."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.statuspage": [
    {
      "type": 0,
      "value": "A software tool for incident communication."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.studio": [
    {
      "type": 0,
      "value": "A space for makers to build and combine automations, agents, and apps into custom solutions that solve your unique business problems."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.talent": [
    {
      "type": 0,
      "value": "Talent is a strategic workforce planning tool that helps you understand, design and build a thriving workforce."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.trello": [
    {
      "type": 0,
      "value": "A visual collaboration tool that organizes your projects into boards, allowing for easy task and project management."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.welcome": [
    {
      "type": 1,
      "value": "waveEmoji"
    },
    {
      "type": 0,
      "value": " G'day, "
    },
    {
      "type": 1,
      "value": "recipientFirstName"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.what-is": [
    {
      "type": 0,
      "value": "What is "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": "? "
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.what-is.new": [
    {
      "children": [
        {
          "type": 0,
          "value": "What is "
        },
        {
          "type": 1,
          "value": "productName"
        },
        {
          "type": 0,
          "value": "?"
        }
      ],
      "type": 8,
      "value": "strong"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body-title.admin": [
    {
      "type": 0,
      "value": "Your admin "
    },
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " invited you to join your team in "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body-title.no-inviter-nor-product": [
    {
      "type": 0,
      "value": "You've been invited to join your team"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body-title.no-product": [
    {
      "type": 1,
      "value": "inviterName"
    },
    {
      "type": 0,
      "value": " invited you to join your team"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body-title.non-ugc": [
    {
      "type": 0,
      "value": "You've been invited to join your team in "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body-title.nth-user": [
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " invited you to join your team in "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body-title.reinvite": [
    {
      "type": 1,
      "value": "inviterName"
    },
    {
      "type": 0,
      "value": " is waiting for you to join your team in "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body-title.rovo-product": [
    {
      "type": 1,
      "value": "inviterName"
    },
    {
      "type": 0,
      "value": " invited you to join them in "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright 2025 Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.links.contact-us": [
    {
      "type": 0,
      "value": "Contact us"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.links.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.links.read-our-blog": [
    {
      "type": 0,
      "value": "Read our blog"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.links.unsubscribe": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.reinvite": [
    {
      "type": 0,
      "value": "Over "
    },
    {
      "type": 1,
      "value": "numberOfCustomers"
    },
    {
      "type": 0,
      "value": " customers use Atlassian apps to accelerate their work"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.rovo.social-proof": [
    {
      "type": 0,
      "value": "Trusted by teams around the world"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.sent-by": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Cloud"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.social-proof": [
    {
      "type": 1,
      "value": "numberOfCustomers"
    },
    {
      "type": 0,
      "value": "+ customers use "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " to move work forward"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.subject": [
    {
      "type": 0,
      "value": "Action requested: "
    },
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " invited you to join your team in "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.subject.invite-with-inviter-and-product": [
    {
      "type": 0,
      "value": "Action requested: "
    },
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " invited you to join your team in "
    },
    {
      "type": 1,
      "value": "subjectName"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.subject.invite-without-inviter-nor-product": [
    {
      "type": 0,
      "value": "Action required: You’re invited to join your team"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.subject.invite-without-product": [
    {
      "type": 0,
      "value": "Action required: "
    },
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " invited you to join your team"
    }
  ],
  "ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.subject.reinvite": [
    {
      "type": 0,
      "value": "Reminder: "
    },
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " invited you to join your team in "
    },
    {
      "type": 1,
      "value": "subjectName"
    }
  ],
  "ax-epsilon.invitations.better.notification.invite.user.body.img.alt": [
    {
      "type": 0,
      "value": "Atlassian Logo"
    }
  ],
  "custom-domain-manager.components.details.assigned_product": [
    {
      "type": 0,
      "value": "Assigned product:"
    }
  ],
  "custom-domain-manager.components.details.custom_domain": [
    {
      "type": 0,
      "value": "Custom domain:"
    }
  ],
  "custom-domain-manager.components.details.not_assigned": [
    {
      "type": 0,
      "value": "Not assigned"
    }
  ],
  "custom-domain-manager.components.details.previous_product": [
    {
      "type": 0,
      "value": "Previous product:"
    }
  ],
  "custom-domain-manager.components.details.redirect_url": [
    {
      "type": 0,
      "value": "Redirect URL:"
    }
  ],
  "custom-domain-manager.components.footer.img.alt": [
    {
      "type": 0,
      "value": "Atlassian Logo"
    }
  ],
  "custom-domain-manager.components.footer.note.no-org-name": [
    {
      "type": 0,
      "value": "You received this because you’re an organization admin"
    }
  ],
  "custom-domain-manager.components.footer.note.org-name": [
    {
      "type": 0,
      "value": "You received this because you’re an organization admin for "
    },
    {
      "type": 1,
      "value": "orgName"
    }
  ],
  "custom-domain-manager.components.footer.text": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Cloud"
    }
  ],
  "custom-domain-manager.components.header.img.alt": [
    {
      "type": 0,
      "value": "Office Building icon"
    }
  ],
  "custom-domain-manager.custom-domain-association-changed.domain-detected": [
    {
      "type": 0,
      "value": "The following custom domain is now assigned to a different product."
    }
  ],
  "custom-domain-manager.custom-domain-association-changed.footnote": [
    {
      "type": 0,
      "value": "No action is required, we just wanted to let you know that the assigned product changed."
    }
  ],
  "custom-domain-manager.custom-domain-association-changed.header": [
    {
      "type": 0,
      "value": "Custom domain is now assigned to a different product"
    }
  ],
  "custom-domain-manager.custom-domain-association-changed.pre-header-domain-product-changed": [
    {
      "type": 0,
      "value": "Your custom domain is now assigned to a different product."
    }
  ],
  "custom-domain-manager.custom-domain-association-changed.subject": [
    {
      "type": 0,
      "value": "Custom domain changed in "
    },
    {
      "type": 1,
      "value": "orgName"
    }
  ],
  "custom-domain-manager.custom-domain-association-changed.subject-redacted": [
    {
      "type": 0,
      "value": "Custom domain changed in your organization"
    }
  ],
  "custom-domain-manager.custom-domain-association-changed.view-custom-domain-button": [
    {
      "type": 0,
      "value": "View custom domain details"
    }
  ],
  "custom-domain-manager.custom-domain-association-removed.actions": [
    {
      "type": 0,
      "value": "To assign this domain to a product, go to "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Products > Product URLs > Custom domains"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " in Atlassian Administration."
    }
  ],
  "custom-domain-manager.custom-domain-association-removed.footnote": [
    {
      "type": 0,
      "value": "People will need to use the default URL "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "previousProductSite"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " to access the "
    },
    {
      "type": 1,
      "value": "previousProduct"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "custom-domain-manager.custom-domain-association-removed.header": [
    {
      "type": 0,
      "value": "Custom domain is no longer assigned to a product"
    }
  ],
  "custom-domain-manager.custom-domain-association-removed.pre-header-domain-product-changed": [
    {
      "type": 0,
      "value": "Your custom domain is not associated with a product. People won't be able to use this domain until this is resolved."
    }
  ],
  "custom-domain-manager.custom-domain-association-removed.subject": [
    {
      "type": 0,
      "value": "Custom domain changed in "
    },
    {
      "type": 1,
      "value": "orgName"
    }
  ],
  "custom-domain-manager.custom-domain-association-removed.subject-redacted": [
    {
      "type": 0,
      "value": "Custom domain changed in your organization"
    }
  ],
  "custom-domain-manager.custom-domain-association-removed.target-removed": [
    {
      "type": 0,
      "value": "The following custom domain is no longer assigned to a product."
    }
  ],
  "custom-domain-manager.custom-domain-association-removed.view-custom-domain-button": [
    {
      "type": 0,
      "value": "View custom domain details"
    }
  ],
  "custom-domain-manager.custom-domain-internal-removed.action": [
    {
      "type": 0,
      "value": "You can recreate the custom domain at any time, but be aware that new CNAME records will be generated, so you'll need to update your DNS."
    }
  ],
  "custom-domain-manager.custom-domain-internal-removed.domain-removed-by-internal-system": [
    {
      "type": 0,
      "value": "The following custom domain has been in a "
    },
    {
      "type": 1,
      "value": "status"
    },
    {
      "type": 0,
      "value": " state for the last 180 days. Because of this state, we can't detect a valid DNS record."
    }
  ],
  "custom-domain-manager.custom-domain-internal-removed.footnote": [
    {
      "type": 0,
      "value": "We don't redirect removed domains, so people will need to use the default URL "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "productSite"
        }
      ],
      "type": 8,
      "value": "strongNoLink"
    },
    {
      "type": 0,
      "value": " to access the "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "custom-domain-manager.custom-domain-internal-removed.header": [
    {
      "type": 0,
      "value": "Custom domain has been removed"
    }
  ],
  "custom-domain-manager.custom-domain-internal-removed.pre-header": [
    {
      "type": 0,
      "value": "Your custom domain was removed. People won't be able to use this domain to access your product."
    }
  ],
  "custom-domain-manager.custom-domain-internal-removed.subject": [
    {
      "type": 0,
      "value": "Custom domain removed in "
    },
    {
      "type": 1,
      "value": "orgName"
    }
  ],
  "custom-domain-manager.custom-domain-internal-removed.subject-redacted": [
    {
      "type": 0,
      "value": "Custom domain removed in your organization"
    }
  ],
  "custom-domain-manager.custom-domain-internal-removed.view-custom-domains-button": [
    {
      "type": 0,
      "value": "View custom domains"
    }
  ],
  "custom-domain-manager.custom-domain-ready-to-activate.domain-detected": [
    {
      "type": 0,
      "value": "We've detected the required DNS records for the following domain."
    }
  ],
  "custom-domain-manager.custom-domain-ready-to-activate.footnote": [
    {
      "type": 0,
      "value": "You can activate this custom domain whenever you're ready to start using it to access the assigned product."
    }
  ],
  "custom-domain-manager.custom-domain-ready-to-activate.header": [
    {
      "type": 0,
      "value": "Custom domain is ready to activate"
    }
  ],
  "custom-domain-manager.custom-domain-ready-to-activate.pre-header-domain-ready": [
    {
      "type": 0,
      "value": "Activate your custom domain so people can use it to access your product."
    }
  ],
  "custom-domain-manager.custom-domain-ready-to-activate.subject": [
    {
      "type": 0,
      "value": "Custom domain is ready to activate in "
    },
    {
      "type": 1,
      "value": "orgName"
    }
  ],
  "custom-domain-manager.custom-domain-ready-to-activate.subject-redacted": [
    {
      "type": 0,
      "value": "Custom domain is ready to activate in your organization"
    }
  ],
  "custom-domain-manager.custom-domain-ready-to-activate.view-custom-domain-button": [
    {
      "type": 0,
      "value": "View custom domain details"
    }
  ],
  "custom-domain-manager.custom-domain-removed.action": [
    {
      "type": 0,
      "value": "You can recreate the custom domain at any time, but be aware that new CNAME records will be generated, so you'll need to update your DNS."
    }
  ],
  "custom-domain-manager.custom-domain-removed.domain-removed": [
    {
      "type": 0,
      "value": "The following custom domain has been removed by an organization admin."
    }
  ],
  "custom-domain-manager.custom-domain-removed.footnote": [
    {
      "type": 0,
      "value": "We don't redirect removed domains, so people will need to use the default URL "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "productSite"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " to access the "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "custom-domain-manager.custom-domain-removed.header": [
    {
      "type": 0,
      "value": "Custom domain has been removed"
    }
  ],
  "custom-domain-manager.custom-domain-removed.pre-header": [
    {
      "type": 0,
      "value": "Your custom domain was removed. People won't be able to use this domain to access your product."
    }
  ],
  "custom-domain-manager.custom-domain-removed.subject": [
    {
      "type": 0,
      "value": "Custom domain removed in "
    },
    {
      "type": 1,
      "value": "orgName"
    }
  ],
  "custom-domain-manager.custom-domain-removed.subject-redacted": [
    {
      "type": 0,
      "value": "Custom domain removed in your organization"
    }
  ],
  "custom-domain-manager.custom-domain-removed.view-custom-domains-button": [
    {
      "type": 0,
      "value": "View custom domains"
    }
  ],
  "custom-domain-manager.custom-domain-suspended.error-window-alt": [
    {
      "type": 0,
      "value": "Error window image"
    }
  ],
  "custom-domain-manager.custom-domain-suspended.footnote": [
    {
      "type": 0,
      "value": "If this keeps happening, "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "contact support"
        }
      ],
      "type": 8,
      "value": "link"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "custom-domain-manager.custom-domain-suspended.header": [
    {
      "type": 0,
      "value": "A custom domain needs immediate attention"
    }
  ],
  "custom-domain-manager.custom-domain-suspended.pre-header-domain-suspended": [
    {
      "type": 0,
      "value": "Your custom domain is either suspended or not available due to an error."
    }
  ],
  "custom-domain-manager.custom-domain-suspended.problem-detected": [
    {
      "type": 0,
      "value": "We detected a problem with the following custom domain. This may be due to a change to your DNS, or because we detected suspicious activity and suspended your domain."
    }
  ],
  "custom-domain-manager.custom-domain-suspended.subject": [
    {
      "type": 0,
      "value": "Custom domain is not available"
    }
  ],
  "custom-domain-manager.custom-domain-suspended.troubleshoot": [
    {
      "type": 0,
      "value": "For information to help you troubleshoot this problem go to "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Products > Product URLs > Custom domains"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " in Atlassian Administration."
    }
  ],
  "custom-domain-manager.custom-domain-suspended.view-custom-domain-button": [
    {
      "type": 0,
      "value": "View custom domain"
    }
  ],
  "custom-domain-manager.custom-domain-suspended.warning": [
    {
      "type": 0,
      "value": "People won't be able to use this domain to access your product until the problem is resolved."
    }
  ],
  "custom-domain-manager.records-error.Error-Window-alt": [
    {
      "type": 0,
      "value": "Error window logo"
    }
  ],
  "custom-domain-manager.records-error.action": [
    {
      "type": 0,
      "value": "We're not sure what went wrong, so to resolve this an organization admin will need to delete the pending custom domain and try again."
    }
  ],
  "custom-domain-manager.records-error.cname-records-not-generated-m2": [
    {
      "type": 0,
      "value": "We received a request from an organization admin to create the following custom domain."
    }
  ],
  "custom-domain-manager.records-error.cname-records-unable": [
    {
      "type": 0,
      "value": "We were unable to generate CNAME records for this domain."
    }
  ],
  "custom-domain-manager.records-error.cname-records-unable-with-url": [
    {
      "type": 0,
      "value": "We were unable to generate CNAME records for "
    },
    {
      "type": 1,
      "value": "url"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "custom-domain-manager.records-error.footnote": [
    {
      "type": 0,
      "value": "If this keeps happening, "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "contact support"
        }
      ],
      "type": 8,
      "value": "supportLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "custom-domain-manager.records-error.header": [
    {
      "type": 0,
      "value": "Unable to generate CNAME records for "
    },
    {
      "type": 1,
      "value": "fqdn"
    }
  ],
  "custom-domain-manager.records-error.pre-header-records-error": [
    {
      "type": 0,
      "value": "You need to recreate your custom domain because the CNAME records weren't generated"
    }
  ],
  "custom-domain-manager.records-error.subject": [
    {
      "type": 0,
      "value": "Custom domain CNAME records were not generated"
    }
  ],
  "custom-domain-manager.records-error.view-cname-records-button": [
    {
      "type": 0,
      "value": "View custom domain"
    }
  ],
  "custom-domain-manager.records-ready.File-Cabinet-Open-alt": [
    {
      "type": 0,
      "value": "File cabinet open logo"
    }
  ],
  "custom-domain-manager.records-ready.cname-records-generated-product": [
    {
      "type": 0,
      "value": "The CNAME records are now ready to add to your DNS provider. This will confirm you own the domain."
    }
  ],
  "custom-domain-manager.records-ready.cname-records-generated-requested-product": [
    {
      "type": 0,
      "value": "We received a request from an organization admin to create the following custom domain."
    }
  ],
  "custom-domain-manager.records-ready.footnote": [
    {
      "type": 0,
      "value": "Once we detect the records you'll be able to activate and start using the custom domain."
    }
  ],
  "custom-domain-manager.records-ready.header-product-support": [
    {
      "type": 0,
      "value": "The CNAME records are ready to use"
    }
  ],
  "custom-domain-manager.records-ready.pre-header-records-ready": [
    {
      "type": 0,
      "value": "Update your DNS with the CNAME records for your custom domain."
    }
  ],
  "custom-domain-manager.records-ready.subject": [
    {
      "type": 0,
      "value": "Custom domain CNAME records are ready"
    }
  ],
  "custom-domain-manager.records-ready.view-cname-records-button": [
    {
      "type": 0,
      "value": "View CNAME records"
    }
  ],
  "custom-domain-manager.records-requested.Gears-alt": [
    {
      "type": 0,
      "value": "Gears logo"
    }
  ],
  "custom-domain-manager.records-requested.cname-records-generated-product": [
    {
      "type": 0,
      "value": "We received a request from an organization admin to create the following custom domain."
    }
  ],
  "custom-domain-manager.records-requested.confirmation-email": [
    {
      "type": 0,
      "value": "We're currently generating the CNAME records that will need to be added to your DNS provider to confirm you own the domain. This usually takes about 30 minutes."
    }
  ],
  "custom-domain-manager.records-requested.footnote": [
    {
      "type": 0,
      "value": "We'll send another email when the CNAME records are ready. Once we detect the records you'll be able to activate and start using the custom domain."
    }
  ],
  "custom-domain-manager.records-requested.header-product": [
    {
      "type": 0,
      "value": "CNAME records will be ready shortly"
    }
  ],
  "custom-domain-manager.records-requested.pre-header-records-requested": [
    {
      "type": 0,
      "value": "An organization admin has requested a new custom domain. CNAME records will be ready soon."
    }
  ],
  "custom-domain-manager.records-requested.subject": [
    {
      "type": 0,
      "value": "Custom domain requested"
    }
  ],
  "custom-domain-manager.records-requested.view-custom-domains-button": [
    {
      "type": 0,
      "value": "View custom domains"
    }
  ],
  "experiment.invite-email-user-to-bundle.admin-role": [
    {
      "type": 0,
      "value": "ADMIN"
    }
  ],
  "experiment.invite-email-user-to-bundle.body": [
    {
      "type": 0,
      "value": "Start planning and tracking work with "
    },
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " and your team. You can share your work and view what your team is doing."
    }
  ],
  "experiment.invite-email-user-to-bundle.body-image-alt": [
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "experiment.invite-email-user-to-bundle.body-reinvite": [
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " invited you to join Jira and Confluence 3 days ago. Start collaborating with your team."
    }
  ],
  "experiment.invite-email-user-to-bundle.button-text.confluence": [
    {
      "type": 0,
      "value": "Go to Confluence"
    }
  ],
  "experiment.invite-email-user-to-bundle.button-text.jira": [
    {
      "type": 0,
      "value": "Go to Jira"
    }
  ],
  "experiment.invite-email-user-to-bundle.confluence.description": [
    {
      "type": 0,
      "value": "A team workspace where knowledge and collaboration meet. Create, collaborate, and organize all your work in one place."
    }
  ],
  "experiment.invite-email-user-to-bundle.invite-user.avatar-alt-text": [
    {
      "type": 0,
      "value": "Inviter user avatar"
    }
  ],
  "experiment.invite-email-user-to-bundle.jira.description": [
    {
      "type": 0,
      "value": "A software tool for project and issue tracking across your team. Plan, track and manage your projects in Jira."
    }
  ],
  "experiment.invite-email-user-to-bundle.learn-more": [
    {
      "type": 0,
      "value": " Learn more"
    }
  ],
  "experiment.invite-email-user-to-bundle.note-title": [
    {
      "type": 0,
      "value": "A note from "
    },
    {
      "type": 1,
      "value": "inviterDisplayName"
    }
  ],
  "experiment.invite-email-user-to-bundle.reminder-subject-text": [
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " is waiting for you to join Jira and Confluence"
    }
  ],
  "experiment.invite-email-user-to-bundle.subject-with-inviter": [
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " invited you to join them in Jira and Confluence"
    }
  ],
  "experiment.invite-email-user-to-bundle.subject-without-inviter": [
    {
      "type": 0,
      "value": "You've been invited to Jira and Confluence"
    }
  ],
  "experiment.invite-email-user-to-bundle.what-is": [
    {
      "type": 0,
      "value": "What is "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": "? "
    }
  ],
  "id-invitations-service.better_notification_invite_user.admin_role": [
    {
      "type": 0,
      "value": "ADMIN"
    }
  ],
  "id-invitations-service.better_notification_invite_user.analytics.description": [
    {
      "type": 0,
      "value": "Visualize data across Atlassian products for actionable insights."
    }
  ],
  "id-invitations-service.better_notification_invite_user.assets.description": [
    {
      "type": 0,
      "value": "From laptops to llamas, bring anything you need to track into a flexible database. Link objects to work items, documents, automations, and more."
    }
  ],
  "id-invitations-service.better_notification_invite_user.avocado.description": [
    {
      "type": 0,
      "value": "Question and answer."
    }
  ],
  "id-invitations-service.better_notification_invite_user.beacon.description": [
    {
      "type": 0,
      "value": "Security monitoring."
    }
  ],
  "id-invitations-service.better_notification_invite_user.body": [
    {
      "type": 0,
      "value": "Start planning and tracking work with "
    },
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " and your team. You can share your work and view what your team is doing."
    }
  ],
  "id-invitations-service.better_notification_invite_user.body.devai": [
    {
      "type": 0,
      "value": "Start using AI to help you get started with coding your work."
    }
  ],
  "id-invitations-service.better_notification_invite_user.body.jira-product-discovery": [
    {
      "type": 0,
      "value": "A dedicated tool for product teams to capture and prioritize ideas, connect business and tech teams, and align everyone—all in Jira."
    }
  ],
  "id-invitations-service.better_notification_invite_user.body.mercury": [
    {
      "type": 0,
      "value": "Understand your company's strategic priorities and start mapping focus areas with your team. Connect goals, work, positions, and funds to maximize your enterprise strategy."
    }
  ],
  "id-invitations-service.better_notification_invite_user.body.rovo.personalised.note": [
    {
      "type": 0,
      "value": "Start using and tracking work with "
    },
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " and your team. You can share your work and view what your team is doing."
    }
  ],
  "id-invitations-service.better_notification_invite_user.body_image_alt": [
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "id-invitations-service.better_notification_invite_user.body_reinvite": [
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " invited you to join "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": ". Start collaborating with your team."
    }
  ],
  "id-invitations-service.better_notification_invite_user.button_text": [
    {
      "type": 0,
      "value": "Accept Invite"
    }
  ],
  "id-invitations-service.better_notification_invite_user.compass.description": [
    {
      "type": 0,
      "value": "Mission control for your distributed architecture."
    }
  ],
  "id-invitations-service.better_notification_invite_user.confluence.description": [
    {
      "type": 0,
      "value": "A team workspace where knowledge and collaboration meet. Create, collaborate, and organize all your work in one place."
    }
  ],
  "id-invitations-service.better_notification_invite_user.devai.description": [
    {
      "type": 0,
      "value": "Rovo Dev is a suite of AI features that help you both review and create code using Atlassian products."
    }
  ],
  "id-invitations-service.better_notification_invite_user.feedback.description": [
    {
      "type": 0,
      "value": "A tool for collecting, organizing, and acting on customer and team feedback."
    }
  ],
  "id-invitations-service.better_notification_invite_user.jira-customer-service.description": [
    {
      "type": 0,
      "value": "Unite Development, Operations, and Customer Service teams on a single platform to resolve support cases faster and deliver exceptional customer experiences."
    }
  ],
  "id-invitations-service.better_notification_invite_user.jira-servicedesk.description": [
    {
      "type": 0,
      "value": "IT service desk and customer service."
    }
  ],
  "id-invitations-service.better_notification_invite_user.jira.description": [
    {
      "type": 0,
      "value": "A software tool for project and issue tracking across your team. Plan, track and manage your projects in Jira."
    }
  ],
  "id-invitations-service.better_notification_invite_user.learn_more": [
    {
      "type": 0,
      "value": " Learn more"
    }
  ],
  "id-invitations-service.better_notification_invite_user.loom.description": [
    {
      "type": 0,
      "value": "Loom is an easy way to create video messages of feedback, ideas, presentations, and more. Work moves forward faster, and you have fewer meetings."
    }
  ],
  "id-invitations-service.better_notification_invite_user.mercury.description": [
    {
      "type": 0,
      "value": "Define and map strategic priorities and track progress with your team."
    }
  ],
  "id-invitations-service.better_notification_invite_user.note_title": [
    {
      "type": 0,
      "value": "A note from "
    },
    {
      "type": 1,
      "value": "inviterDisplayName"
    }
  ],
  "id-invitations-service.better_notification_invite_user.opsgenie.description": [
    {
      "type": 0,
      "value": "A software tool for incident management. Track on-call alerts and notifications."
    }
  ],
  "id-invitations-service.better_notification_invite_user.reminder_subject_text": [
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " is waiting for you to join "
    },
    {
      "type": 1,
      "value": "subjectName"
    }
  ],
  "id-invitations-service.better_notification_invite_user.rovo.description": [
    {
      "type": 0,
      "value": "Start using the same AI your team uses to find answers across your apps and work faster with chat, search, and agents."
    }
  ],
  "id-invitations-service.better_notification_invite_user.statuspage.description": [
    {
      "type": 0,
      "value": "A software tool for incident communication."
    }
  ],
  "id-invitations-service.better_notification_invite_user.studio.description": [
    {
      "type": 0,
      "value": "A space for makers to build and combine automations, agents, and apps into custom solutions that solve your unique business problems."
    }
  ],
  "id-invitations-service.better_notification_invite_user.subject_with_inviter": [
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " invited you to join them in "
    },
    {
      "type": 1,
      "value": "subjectName"
    }
  ],
  "id-invitations-service.better_notification_invite_user.subject_without_inviter": [
    {
      "type": 0,
      "value": "You've been invited to "
    },
    {
      "type": 1,
      "value": "subjectName"
    }
  ],
  "id-invitations-service.better_notification_invite_user.subject_without_subject_name": [
    {
      "type": 0,
      "value": "You've been invited"
    }
  ],
  "id-invitations-service.better_notification_invite_user.talent.description": [
    {
      "type": 0,
      "value": "Talent is a strategic workforce planning tool that helps you understand, design and build a thriving workforce."
    }
  ],
  "id-invitations-service.better_notification_invite_user.townsquare.description": [
    {
      "type": 0,
      "value": "A software tool to connect work across your company. Share work and get aligned across teams."
    }
  ],
  "id-invitations-service.better_notification_invite_user.what_is": [
    {
      "type": 0,
      "value": "What is "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": "? "
    }
  ],
  "id-invitations-service.components.VortexProductComponent.bitbucket.description": [
    {
      "type": 0,
      "value": "Code management and collaboration."
    }
  ],
  "id-invitations-service.components.VortexProductComponent.trello.description": [
    {
      "type": 0,
      "value": "Tasks and project management."
    }
  ],
  "id-invitations-service.invitation-urls-notify-admin.body": [
    {
      "type": 1,
      "value": "userLink"
    },
    {
      "type": 0,
      "value": " will now have access to "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " and will consume a seat in your license."
    }
  ],
  "id-invitations-service.invitation-urls-notify-admin.header": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": " joined "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service.invitation-urls-notify-admin.intro": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "email"
    },
    {
      "type": 0,
      "value": ") joined "
    },
    {
      "type": 1,
      "value": "siteName"
    },
    {
      "type": 0,
      "value": " via your "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " invitation URL."
    }
  ],
  "id-invitations-service.invitation-urls-notify-admin.request-access.button": [
    {
      "type": 0,
      "value": "Go to site administration"
    }
  ],
  "id-invitations-service.invitation-urls-notify-admin.subject": [
    {
      "type": 0,
      "value": "Your team is growing"
    }
  ],
  "id-invitations-service.invite-user.avatar-alt-text": [
    {
      "type": 0,
      "value": "Inviter user avatar"
    }
  ],
  "id-invitations-service.invite-user.button-text": [
    {
      "type": 0,
      "value": "Join the team"
    }
  ],
  "id-invitations-service.invite-user.header": [
    {
      "type": 0,
      "value": "Your team is waiting for you to join them"
    }
  ],
  "id-invitations-service.invite-user.invite-text-with-inviter-and-site": [
    {
      "type": 1,
      "value": "inviterName"
    },
    {
      "type": 0,
      "value": " has invited you to collaborate on "
    },
    {
      "type": 1,
      "value": "siteUrl"
    }
  ],
  "id-invitations-service.invite-user.invite-text-with-inviter-without-site": [
    {
      "type": 1,
      "value": "inviterName"
    },
    {
      "type": 0,
      "value": " has invited you to collaborate with the "
    },
    {
      "type": 1,
      "value": "instanceName"
    },
    {
      "type": 0,
      "value": " team"
    }
  ],
  "id-invitations-service.invite-user.invite-text-without-inviter-and-site": [
    {
      "type": 0,
      "value": "You've been invited to collaborate with the "
    },
    {
      "type": 1,
      "value": "instanceName"
    },
    {
      "type": 0,
      "value": " team"
    }
  ],
  "id-invitations-service.invite-user.invite-text-without-inviter-with-site": [
    {
      "type": 0,
      "value": "You've been invited to collaborate on "
    },
    {
      "type": 1,
      "value": "siteUrl"
    }
  ],
  "id-invitations-service.invite-user.reminder-subject-text": [
    {
      "type": 0,
      "value": "[Reminder]"
    }
  ],
  "id-invitations-service.invite-user.subject-with-inviter": [
    {
      "type": 1,
      "value": "reminderValue"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "inviterName"
    },
    {
      "type": 0,
      "value": " is waiting for you to join them"
    }
  ],
  "id-invitations-service.invite-user.subject-without-inviter": [
    {
      "type": 1,
      "value": "reminderValue"
    },
    {
      "type": 0,
      "value": " Your team is waiting for you to join them"
    }
  ],
  "id-invitations-service.invite-user.team-message-with-inviter": [
    {
      "type": 0,
      "value": "Here's what "
    },
    {
      "type": 1,
      "value": "inviterName"
    },
    {
      "type": 0,
      "value": " and your team are using to work seamlessly and accomplish more, together:"
    }
  ],
  "id-invitations-service.invite-user.team-message-without-inviter": [
    {
      "type": 0,
      "value": "Here's what your team are using to work seamlessly and accomplish more, together:"
    }
  ],
  "id-invitations-service.invite_user.avatar_alt_text": [
    {
      "type": 0,
      "value": "Inviter user avatar"
    }
  ],
  "id-invitations-service.join-multiple-products-admin-notification.invite-text-with-inviter": [
    {
      "type": 1,
      "value": "joinedUserName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "joinedUserEmailAddress"
    },
    {
      "type": 0,
      "value": ") has just joined "
    },
    {
      "type": 1,
      "value": "siteUrl"
    },
    {
      "type": 0,
      "value": " in "
    },
    {
      "type": 1,
      "value": "organizationName"
    },
    {
      "type": 0,
      "value": ". They have access to the following products:"
    }
  ],
  "id-invitations-service.join-multiple-products-admin-notification.review-settings-text": [
    {
      "type": 0,
      "value": "If something doesn't look right, "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "review your user access settings"
        }
      ],
      "type": 8,
      "value": "link"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "id-invitations-service.join-multiple-products-admin-notification.subject-text": [
    {
      "type": 1,
      "value": "joinedUserName"
    },
    {
      "type": 0,
      "value": " has joined "
    },
    {
      "type": 1,
      "value": "organizationName"
    }
  ],
  "id-invitations-service.join-multiple-products-admin-notification.title": [
    {
      "type": 1,
      "value": "joinedUserName"
    },
    {
      "type": 0,
      "value": " has joined "
    },
    {
      "type": 1,
      "value": "organizationName"
    }
  ],
  "id-invitations-service.join-multiple-products-admin-notification.view-profile-button-text": [
    {
      "type": 0,
      "value": "View "
    },
    {
      "type": 1,
      "value": "joinedUserName"
    },
    {
      "type": 0,
      "value": "'s profile"
    }
  ],
  "id-invitations-service.join-product-admin-notification.invite-text-with-inviter": [
    {
      "type": 1,
      "value": "joinedUserName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "joinedUserEmailAddress"
    },
    {
      "type": 0,
      "value": ") has just joined "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "siteUrl"
    },
    {
      "type": 0,
      "value": ") in "
    },
    {
      "type": 1,
      "value": "organizationName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "id-invitations-service.join-product-admin-notification.review-settings-text": [
    {
      "type": 0,
      "value": "If something doesn't look right, "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "review your user access settings"
        }
      ],
      "type": 8,
      "value": "link"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "id-invitations-service.join-product-admin-notification.subject-text": [
    {
      "type": 1,
      "value": "joinedUserName"
    },
    {
      "type": 0,
      "value": " has joined your "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "id-invitations-service.join-product-admin-notification.title": [
    {
      "type": 1,
      "value": "joinedUserName"
    },
    {
      "type": 0,
      "value": " has joined "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "id-invitations-service.join-product-admin-notification.view-profile-button-text": [
    {
      "type": 0,
      "value": "View "
    },
    {
      "type": 1,
      "value": "joinedUserName"
    },
    {
      "type": 0,
      "value": "'s profile"
    }
  ],
  "id-invitations-service.open-invite-notification.header-invited-user": [
    {
      "type": 1,
      "value": "inviterPublicName"
    },
    {
      "type": 0,
      "value": " invited "
    },
    {
      "type": 1,
      "value": "inviteePublicName"
    },
    {
      "type": 0,
      "value": " to your Atlassian site"
    }
  ],
  "id-invitations-service.open-invite-notification.intro-invited-user": [
    {
      "type": 1,
      "value": "inviterPublicName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "inviterEmail"
    },
    {
      "type": 0,
      "value": ") has invited "
    },
    {
      "type": 1,
      "value": "inviteePublicName"
    },
    {
      "type": 0,
      "value": " to work with your team. Here's some more information about them:"
    }
  ],
  "id-invitations-service.open-invite-notification.invite-settings-link": [
    {
      "children": [
        {
          "type": 0,
          "value": "View your invite settings"
        }
      ],
      "type": 8,
      "value": "link"
    }
  ],
  "id-invitations-service.open-invite-notification.subject-invited": [
    {
      "type": 1,
      "value": "inviterPublicName"
    },
    {
      "type": 0,
      "value": " invited "
    },
    {
      "type": 1,
      "value": "inviteePublicName"
    },
    {
      "type": 0,
      "value": " to your Atlassian site"
    }
  ],
  "id-invitations-service.open-invite-notification.view-profile.button": [
    {
      "type": 0,
      "value": "View profile"
    }
  ],
  "id-invitations-service.pending-invite-approve-original-user.header": [
    {
      "type": 1,
      "value": "requesterDisplayName"
    },
    {
      "type": 0,
      "value": " wanted you to get access to "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service.pending-invite-approve-original-user.intro-invited-user": [
    {
      "type": 0,
      "value": "Your site admin ("
    },
    {
      "type": 1,
      "value": "siteAdmin"
    },
    {
      "type": 0,
      "value": ") granted you access to "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "siteName"
    }
  ],
  "id-invitations-service.pending-invite-approve-original-user.intro-user-requested-access": [
    {
      "type": 0,
      "value": "Your site admin "
    },
    {
      "type": 1,
      "value": "siteAdminInfo"
    },
    {
      "type": 0,
      "value": " granted you access to "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "siteName"
    }
  ],
  "id-invitations-service.pending-invite-approve-original-user.request-access.button": [
    {
      "type": 0,
      "value": "Open "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service.pending-invite-approve-original-user.subject": [
    {
      "type": 0,
      "value": "You have access to "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service.pending-invite-reject-user.header": [
    {
      "type": 0,
      "value": "The user at "
    },
    {
      "type": 1,
      "value": "invitedUserEmail"
    },
    {
      "type": 0,
      "value": " cannot access "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service.pending-invite-reject-user.intro-internal": [
    {
      "type": 0,
      "value": "Your site admin ("
    },
    {
      "type": 1,
      "value": "siteAdmin"
    },
    {
      "type": 0,
      "value": ") at "
    },
    {
      "type": 1,
      "value": "siteName"
    },
    {
      "type": 0,
      "value": " denied your request for "
    },
    {
      "type": 1,
      "value": "invitedUserEmail"
    },
    {
      "type": 0,
      "value": " to access "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "id-invitations-service.pending-invite-reject-user.subject": [
    {
      "type": 0,
      "value": "Your admin declined your invitation to another user"
    }
  ],
  "id-invitations-service.product-component.product-logo.alt-text": [
    {
      "type": 1,
      "value": "displayName"
    },
    {
      "type": 0,
      "value": " logo"
    }
  ],
  "id-invitations-service.request-access-approve-user.header": [
    {
      "type": 0,
      "value": "You can now see the content you requested"
    }
  ],
  "id-invitations-service.request-access-approve-user.intro-invited-user": [
    {
      "type": 0,
      "value": "Your site admin ("
    },
    {
      "type": 1,
      "value": "email"
    },
    {
      "type": 0,
      "value": ") granted you access to "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "site"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "id-invitations-service.request-access-approve-user.intro-user-requested-access": [
    {
      "type": 0,
      "value": "Your site admin granted you access to "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "site"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "id-invitations-service.request-access-approve-user.loom-value-prop": [
    {
      "type": 0,
      "value": "Record and share Loom videos to keep your team up to date on progress, feedback, ideas, and more."
    }
  ],
  "id-invitations-service.request-access-approve-user.new-loom-header": [
    {
      "type": 0,
      "value": "Start sharing async video with Loom"
    }
  ],
  "id-invitations-service.request-access-approve-user.request-access.button": [
    {
      "type": 0,
      "value": "Open "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service.request-access-approve-user.subject": [
    {
      "type": 0,
      "value": "You have access to "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service.request-access-reject-user.deny-reason": [
    {
      "type": 1,
      "value": "denyReason"
    }
  ],
  "id-invitations-service.request-access-reject-user.header": [
    {
      "type": 0,
      "value": "We can't show you the content you requested"
    }
  ],
  "id-invitations-service.request-access-reject-user.intro-external": [
    {
      "type": 0,
      "value": "The site admin denied your request for access to "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "siteName"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "id-invitations-service.request-access-reject-user.intro-internal": [
    {
      "type": 0,
      "value": "Your site admin denied your request for access to "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "siteName"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "id-invitations-service.request-access-reject-user.intro-internal-specified-site-admin": [
    {
      "type": 0,
      "value": "Your site admin ("
    },
    {
      "type": 1,
      "value": "email"
    },
    {
      "type": 0,
      "value": ") denied your request for access to "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "siteName"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "id-invitations-service.request-access-reject-user.subject": [
    {
      "type": 0,
      "value": "You were denied access to "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service.request-access.access-details.app-requested-label": [
    {
      "type": 0,
      "value": "App Requested"
    }
  ],
  "id-invitations-service.request-access.access-details.requestTime-label": [
    {
      "type": 0,
      "value": "Date"
    }
  ],
  "id-invitations-service.request-access.access-details.requested-by-label": [
    {
      "type": 0,
      "value": "Requested by"
    }
  ],
  "id-invitations-service.request-access.access-details.requester-info": [
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "inviterEmail"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "id-invitations-service.request-access.access-details.summary-label": [
    {
      "type": 0,
      "value": "Summary"
    }
  ],
  "id-invitations-service.request-access.access-details.summary-text-detailed": [
    {
      "type": 1,
      "value": "note"
    }
  ],
  "id-invitations-service.request-access.access-details.summary-text-simple": [
    {
      "type": 0,
      "value": "Hi, admin 👋 I'd like to use "
    },
    {
      "type": 1,
      "value": "requestedProductName"
    },
    {
      "type": 0,
      "value": " to collaborate with my team."
    }
  ],
  "id-invitations-service.request-access.footer.received-as-admin": [
    {
      "type": 0,
      "value": "You received this email because you're an admin for "
    },
    {
      "type": 1,
      "value": "siteName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "id-invitations-service.request-access.footer.sent-by-atlassian": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Administration."
    }
  ],
  "id-invitations-service.request-access.header-access-details": [
    {
      "type": 0,
      "value": "Access Details"
    }
  ],
  "id-invitations-service.request-access.header-grant-access": [
    {
      "type": 0,
      "value": "Grant access to "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": "?"
    }
  ],
  "id-invitations-service.request-access.header-requester-information": [
    {
      "type": 0,
      "value": "Requester information"
    }
  ],
  "id-invitations-service.request-access.header.atlassian-logo.alt-text": [
    {
      "type": 0,
      "value": "Atlassian logo"
    }
  ],
  "id-invitations-service.request-access.requester-details.existing-app-access-label": [
    {
      "type": 0,
      "value": "Existing app access:"
    }
  ],
  "id-invitations-service.request-access.requester-details.existing-apps-list": [
    {
      "type": 1,
      "value": "existingAppsList"
    }
  ],
  "id-invitations-service.request-access.requester-details.requester-email-only": [
    {
      "type": 1,
      "value": "requesterEmail"
    }
  ],
  "id-invitations-service.request-access.requester-details.requester-info": [
    {
      "type": 1,
      "value": "requesterName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "requesterEmail"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "id-invitations-service.request-access.requester-details.who-needs-access-label": [
    {
      "type": 0,
      "value": "Who needs access"
    }
  ],
  "id-invitations-service.request-access.site-header.building-icon-alt": [
    {
      "type": 0,
      "value": "Office Building icon"
    }
  ],
  "id-invitations-service.vogue-migration-notify-admin.cta-button-new.org-admin": [
    {
      "type": 0,
      "value": "Explore the new settings"
    }
  ],
  "id-invitations-service.vogue-migration-notify-admin.cta-button-new.site-admin": [
    {
      "type": 0,
      "value": "Learn more about these changes"
    }
  ],
  "id-invitations-service.vogue-migration-notify-admin.header.org-admin": [
    {
      "type": 0,
      "value": "Welcome to your centralized user access settings"
    }
  ],
  "id-invitations-service.vogue-migration-notify-admin.header.site-admin": [
    {
      "type": 0,
      "value": "We've moved your site access settings"
    }
  ],
  "id-invitations-service.vogue-migration-notify-admin.message-body-p1.org-admin": [
    {
      "type": 0,
      "value": "We've just "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "rolled out improvements to your site access settings"
        }
      ],
      "type": 8,
      "value": "link"
    },
    {
      "type": 0,
      "value": ". You'll find your organization's new "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "User access settings"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " at "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "admin.atlassian.com"
        }
      ],
      "type": 8,
      "value": "adminLink"
    },
    {
      "type": 0,
      "value": " under Products."
    }
  ],
  "id-invitations-service.vogue-migration-notify-admin.message-body-p1.site-admin": [
    {
      "type": 0,
      "value": "We've just rolled out changes to your site access settings. The new "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "User access settings"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " experience is now available for your Atlassian organization."
    }
  ],
  "id-invitations-service.vogue-migration-notify-admin.message-body-p2.org-admin": [
    {
      "type": 0,
      "value": "We've centralized these settings to give you more flexibility when pre-approving email domains to access your products."
    }
  ],
  "id-invitations-service.vogue-migration-notify-admin.message-body-p2.site-admin": [
    {
      "type": 0,
      "value": "We've centralized these settings to give your organization more flexibility when pre-approving email domains to access your products."
    }
  ],
  "id-invitations-service.vogue-migration-notify-admin.message-body-p3.site-admin": [
    {
      "children": [
        {
          "type": 0,
          "value": "What does this mean for me?"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "id-invitations-service.vogue-migration-notify-admin.message-body-p4.site-admin": [
    {
      "type": 0,
      "value": "Site admins no longer have access to these settings, but your organization admin still has full control."
    }
  ],
  "id-invitations-service.vogue-migration-notify-admin.pre-header-new.org-admin": [
    {
      "type": 0,
      "value": "You'll now have more flexibility when approving which email domains can get access to your products."
    }
  ],
  "id-invitations-service.vogue-migration-notify-admin.pre-header-new.site-admin": [
    {
      "type": 0,
      "value": "We've given your organization more flexibility to approve which email domains can get access to your products."
    }
  ],
  "id-invitations-service.vogue-migration-notify-admin.subject.org-admin": [
    {
      "type": 0,
      "value": "Improvements to your site access settings"
    }
  ],
  "id-invitations-service.vogue-migration-notify-admin.subject.site-admin": [
    {
      "type": 0,
      "value": "Changes to your site access settings"
    }
  ],
  "id-invitations-service.vortex-invite-user.avatar-alt-text": [
    {
      "type": 0,
      "value": "Inviter user avatar"
    }
  ],
  "id-invitations-service.vortex-invite-user.button-text": [
    {
      "type": 0,
      "value": "Join the team"
    }
  ],
  "id-invitations-service.vortex-invite-user.header": [
    {
      "type": 0,
      "value": "Your team is waiting for you to join them"
    }
  ],
  "id-invitations-service.vortex-invite-user.invite-text-with-inviter": [
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " has invited you to collaborate on "
    },
    {
      "type": 1,
      "value": "organizationName"
    }
  ],
  "id-invitations-service.vortex-invite-user.invite-text-without-inviter": [
    {
      "type": 0,
      "value": "You've been invited to collaborate on "
    },
    {
      "type": 1,
      "value": "organizationName"
    }
  ],
  "id-invitations-service.vortex-invite-user.subject-with-inviter": [
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " has invited you to join them"
    }
  ],
  "id-invitations-service.vortex-invite-user.subject-without-inviter": [
    {
      "type": 0,
      "value": "Your team is waiting for you to join them"
    }
  ],
  "id-invitations-service.vortex-invite-user.team-message-with-inviter": [
    {
      "type": 0,
      "value": "Here's what "
    },
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " and your team are using to work seamlessly and accomplish more, together:"
    }
  ],
  "id-invitations-service.vortex-invite-user.team-message-without-inviter": [
    {
      "type": 0,
      "value": "Here's what your team are using to work seamlessly and accomplish more, together:"
    }
  ],
  "id-invitations-service/components/InviteFooter/text": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Cloud"
    }
  ],
  "id-invitations-service/components/InviteFooter/unsubscribe": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "id-invitations-service/components/JoinProductFooter/admin-site-url-text": [
    {
      "type": 0,
      "value": "You are receiving this email because you are a listed administrator of "
    },
    {
      "type": 1,
      "value": "orgName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "id-invitations-service/components/JoinProductFooter/text": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Cloud"
    }
  ],
  "id-invitations-service/components/ProductComponent/analytics/description": [
    {
      "type": 0,
      "value": "Actionable insights for agile teams"
    }
  ],
  "id-invitations-service/components/ProductComponent/assets/description": [
    {
      "type": 0,
      "value": "IT asset management"
    }
  ],
  "id-invitations-service/components/ProductComponent/avocado/description": [
    {
      "type": 0,
      "value": "Question and answer"
    }
  ],
  "id-invitations-service/components/ProductComponent/beacon/description": [
    {
      "type": 0,
      "value": "Security monitoring"
    }
  ],
  "id-invitations-service/components/ProductComponent/bitbucket/description": [
    {
      "type": 0,
      "value": "Code management and collaboration"
    }
  ],
  "id-invitations-service/components/ProductComponent/compass/description": [
    {
      "type": 0,
      "value": "Mission control for your distributed architecture"
    }
  ],
  "id-invitations-service/components/ProductComponent/confluence/description": [
    {
      "type": 0,
      "value": "Document collaboration"
    }
  ],
  "id-invitations-service/components/ProductComponent/devai/description": [
    {
      "type": 0,
      "value": "AI for developers"
    }
  ],
  "id-invitations-service/components/ProductComponent/feedback/description": [
    {
      "type": 0,
      "value": "Collect and manage feedback"
    }
  ],
  "id-invitations-service/components/ProductComponent/jira-core/description": [
    {
      "type": 0,
      "value": "Essential business management"
    }
  ],
  "id-invitations-service/components/ProductComponent/jira-customer-service/description": [
    {
      "type": 0,
      "value": "Customer service management"
    }
  ],
  "id-invitations-service/components/ProductComponent/jira-product-discovery/description": [
    {
      "type": 0,
      "value": "Transform product ideas into business impact"
    }
  ],
  "id-invitations-service/components/ProductComponent/jira-servicedesk/description": [
    {
      "type": 0,
      "value": "IT service desk and customer service"
    }
  ],
  "id-invitations-service/components/ProductComponent/jira-software/description": [
    {
      "type": 0,
      "value": "Project and issue tracking"
    }
  ],
  "id-invitations-service/components/ProductComponent/jira/description": [
    {
      "type": 0,
      "value": "Project and issue tracking"
    }
  ],
  "id-invitations-service/components/ProductComponent/loom/description": [
    {
      "type": 0,
      "value": "Record and share video messages"
    }
  ],
  "id-invitations-service/components/ProductComponent/mercury/description": [
    {
      "type": 0,
      "value": "Define strategic priorities and track progress"
    }
  ],
  "id-invitations-service/components/ProductComponent/opsgenie/description": [
    {
      "type": 0,
      "value": "Modern incident management"
    }
  ],
  "id-invitations-service/components/ProductComponent/statuspage/description": [
    {
      "type": 0,
      "value": "Incident communication"
    }
  ],
  "id-invitations-service/components/ProductComponent/studio/description": [
    {
      "type": 0,
      "value": "Build custom solutions with automations, agents, and apps"
    }
  ],
  "id-invitations-service/components/ProductComponent/talent/description": [
    {
      "type": 0,
      "value": "Strategic workforce planning"
    }
  ],
  "id-invitations-service/components/ProductComponent/townsquare/description": [
    {
      "type": 0,
      "value": "Your company project, goal, people and help directory"
    }
  ],
  "id-invitations-service/components/ProductComponent/trello/description": [
    {
      "type": 0,
      "value": "Tasks and project management"
    }
  ],
  "id-invitations-service/components/ProductComponent/unified-help/description": [
    {
      "type": 0,
      "value": "Help for All"
    }
  ],
  "id-invitations-service/components/UserInfo/avatar_alt_text": [
    {
      "type": 0,
      "value": "User avatar"
    }
  ],
  "id-invitations-service/open_invite_notification/no_products": [
    {
      "type": 0,
      "value": "New user at "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "site"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "id-invitations-service/open_invite_notification/user_many_products": [
    {
      "type": 0,
      "value": "Already using "
    },
    {
      "type": 1,
      "value": "products"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "site"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "id-invitations-service/open_invite_notification/user_products": [
    {
      "type": 0,
      "value": "Already using "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "site"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "id-invitations-service/request-access/groot/ra-1-3/subject-line-1": [
    {
      "type": 0,
      "value": "Access request: "
    },
    {
      "type": 1,
      "value": "requesterDisplayName"
    },
    {
      "type": 0,
      "value": " is waiting to join their team in "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service/request-access/groot/ra-1-3/subject-line-10": [
    {
      "type": 0,
      "value": "🔒 "
    },
    {
      "type": 1,
      "value": "requesterDisplayName"
    },
    {
      "type": 0,
      "value": " requested access to "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service/request-access/groot/ra-1-3/subject-line-2": [
    {
      "type": 0,
      "value": "Review request: "
    },
    {
      "type": 1,
      "value": "requesterDisplayName"
    },
    {
      "type": 0,
      "value": " is asking to join "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service/request-access/groot/ra-1-3/subject-line-3": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " Access request from "
    },
    {
      "type": 1,
      "value": "requesterDisplayName"
    }
  ],
  "id-invitations-service/request-access/groot/ra-1-3/subject-line-4": [
    {
      "type": 1,
      "value": "requesterDisplayName"
    },
    {
      "type": 0,
      "value": " is waiting - Approve their request to join "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service/request-access/groot/ra-1-3/subject-line-5": [
    {
      "type": 0,
      "value": "Don't miss "
    },
    {
      "type": 1,
      "value": "requesterDisplayName"
    },
    {
      "type": 0,
      "value": "'s request to join "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service/request-access/groot/ra-1-3/subject-line-6": [
    {
      "type": 0,
      "value": "Hey "
    },
    {
      "type": 1,
      "value": "adminDisplayName"
    },
    {
      "type": 0,
      "value": ", can "
    },
    {
      "type": 1,
      "value": "requesterDisplayName"
    },
    {
      "type": 0,
      "value": " join their team in "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": "?"
    }
  ],
  "id-invitations-service/request-access/groot/ra-1-3/subject-line-7": [
    {
      "type": 0,
      "value": "Approve "
    },
    {
      "type": 1,
      "value": "requesterDisplayName"
    },
    {
      "type": 0,
      "value": "'s request to join "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service/request-access/groot/ra-1-3/subject-line-8": [
    {
      "type": 0,
      "value": "Someone is requesting to join "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service/request-access/groot/ra-1-3/subject-line-9": [
    {
      "type": 1,
      "value": "requesterDisplayName"
    },
    {
      "type": 0,
      "value": " requested access to join "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service/request-access/groot/ra-2/subject-line-1": [
    {
      "type": 0,
      "value": "Access request: "
    },
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " needs "
    },
    {
      "type": 1,
      "value": "requesterDisplayName"
    },
    {
      "type": 0,
      "value": " to join "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service/request-access/groot/ra-2/subject-line-2": [
    {
      "type": 0,
      "value": "Review request: "
    },
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " is asking for "
    },
    {
      "type": 1,
      "value": "requesterDisplayName"
    },
    {
      "type": 0,
      "value": " to join "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service/request-access/groot/ra-2/subject-line-3": [
    {
      "type": 0,
      "value": "Approve "
    },
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": "'s request for "
    },
    {
      "type": 1,
      "value": "requesterDisplayName"
    },
    {
      "type": 0,
      "value": " to join "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service/request-access/groot/ra-2/subject-line-4": [
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " requested "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " access for "
    },
    {
      "type": 1,
      "value": "requesterDisplayName"
    }
  ],
  "id-invitations-service/request-access/groot/ra-2/subject-line-5": [
    {
      "type": 0,
      "value": "Someone needs access to "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service/request-access/groot/ra-2/subject-line-6": [
    {
      "type": 0,
      "value": "🔒 "
    },
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " needs teammate to gain access to "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service/request_access/approve_message_site_administration": [
    {
      "type": 0,
      "value": "You can find and manage all your access requests in "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Site administration"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "id-invitations-service/request_access/approve_message_user_requests": [
    {
      "type": 0,
      "value": "You can find and manage all your access requests in "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "User requests"
        }
      ],
      "type": 8,
      "value": "bold"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "id-invitations-service/request_access/header-invited-user": [
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " has requested for "
    },
    {
      "type": 1,
      "value": "requesterDisplayName"
    },
    {
      "type": 0,
      "value": " to join "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service/request_access/header-user-requested-access": [
    {
      "type": 1,
      "value": "requesterDisplayName"
    },
    {
      "type": 0,
      "value": " has requested to join "
    },
    {
      "type": 1,
      "value": "product"
    }
  ],
  "id-invitations-service/request_access/intro-invited-user": [
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "inviterEmail"
    },
    {
      "type": 0,
      "value": ") wants "
    },
    {
      "type": 1,
      "value": "requesterDisplayName"
    },
    {
      "type": 0,
      "value": " to join "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " so they can work together. Here's some more information about them:"
    }
  ],
  "id-invitations-service/request_access/intro-user-requested-access": [
    {
      "type": 1,
      "value": "requesterDisplayName"
    },
    {
      "type": 0,
      "value": " wants to join "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": ". Here's some more information about them:"
    }
  ],
  "id-invitations-service/request_access/no-email": [
    {
      "type": 0,
      "value": "No email provided"
    }
  ],
  "id-invitations-service/request_access/no_products": [
    {
      "type": 0,
      "value": "Doesn't have access to any products on "
    },
    {
      "type": 1,
      "value": "siteLink"
    },
    {
      "type": 0,
      "value": " yet."
    }
  ],
  "id-invitations-service/request_access/request_access/approve-button": [
    {
      "type": 0,
      "value": "Approve request"
    }
  ],
  "id-invitations-service/request_access/request_access/button": [
    {
      "type": 0,
      "value": "Review request"
    }
  ],
  "id-invitations-service/request_access/subject": [
    {
      "type": 1,
      "value": "requesterDisplayName"
    },
    {
      "type": 0,
      "value": " needs to join "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "id-invitations-service/request_access/subject-invited": [
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " needs "
    },
    {
      "type": 1,
      "value": "requesterDisplayName"
    },
    {
      "type": 0,
      "value": " to join "
    },
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "id-invitations-service/request_access/user_many_products": [
    {
      "type": 0,
      "value": "Already using "
    },
    {
      "type": 1,
      "value": "products"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "lastProduct"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "siteLink"
    }
  ],
  "id-invitations-service/request_access/user_products": [
    {
      "type": 0,
      "value": "Already using "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "siteLink"
    }
  ],
  "identity-mailer.components.footer.message": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Cloud"
    }
  ]
}